import { FC, memo } from 'react';

import { CardSpotlight } from '../ui/card-spotlight';
import { MovingBorder } from '../ui/moving-border';
import { WorkExperienceItem } from './types/work-experience';

interface WorkExperienceCardProps {
  item: WorkExperienceItem;
}

export const WorkExperienceCard: FC<WorkExperienceCardProps> = memo(({ item }) => {
  return (
    <MovingBorder duration={8000} rx="0" ry="0" borderRadius="1rem" borderClassName="size-40">
      <CardSpotlight className="h-fit w-full rounded-2xl flex flex-col gap-y-2 bg-[rgba(20,22,34,0.85)] border border-white/[0.08]">
        <h3 className="text-xl font-semibold text-white relative z-20">{item.position}</h3>
        <p className="text-sm text-gray-400 relative font-bold z-20">
          {item.companyName}
        </p>
        <p className="text-xs italic text-muted-foreground relative font-bold z-20">
          {item.companyDescription}
        </p>
        <ul className="mt-4 space-y-2 text-gray-300 list-disc list-inside relative z-20">
          {item.achievements.map((achievement, index) => (
            <li key={index} className="text-sm">{achievement}</li>
          ))}
        </ul>
      </CardSpotlight>
    </MovingBorder>
  );
});

WorkExperienceCard.displayName = 'WorkExperienceCard';
